import React, { useEffect, useState } from 'react';
import './UserControl.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Space, Table, Tag } from 'antd';
import { useAuth } from '../../AuthContext';
import { API_URL } from '../../Config';

//import DatePicker from 'react-datepicker';

const UserControl = () => {
  const { user } = useAuth();
  const username = user.user;
  const [users, setUsers] = useState([]);
  const [activeEmployees, setActiveEmployees] = useState([]);
  const [activeUserCount, setActiveUserCount] = useState();

  useEffect(() => {
    let endpoint = API_URL + `/users/?filter=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/users';
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setUsers(data))
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  useEffect(() => {
    let endpoint = API_URL + `/users/?filter=${username.username}`;
  
    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/users';
    }
  
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => {
        // Filter out users with a valid punch_in and no punch_out
        const activeUsers = data.filter((user) => (user.punch_in !== null && user.punch_in !== undefined )&& (user.punch_out === null || user.punch_out === undefined || user.punch_out === ''));
        setActiveEmployees(activeUsers); // Set only active users
      })
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  useEffect (()=>{
    if(activeEmployees.length > 0){
      let activeUser = 0;
      activeUser = activeEmployees.length;
      setActiveUserCount(activeUser);
     } else {
      setActiveUserCount(0);
     }    
  },[activeEmployees])
  

const [state, setState] = useState([
    {
        startDate: new Date(),
        endDate: null,
        key: 'selection'
    }
]);



const columns = [
  {
    title: 'Index',
    dataIndex: 'Index',
    key: 'Index',
    width: '7%',
  },
  {
    title: 'Active',
    key: 'Active',
    width: '7%',
    render: (_, record) => (
      <Space size="middle">
        {/*{record.name}*/}
        <div className={`subrow2_column1_AttendancePage ${record.isActive ? 'GreenCircle_AttendancePage' : 'RedCircle_AttendancePage'}`}></div>

      </Space>
    ),
  },
  {
    title: 'Name',
    dataIndex: 'Name',
    key: 'Name',
    width:'20%',
  },
  {
    title: 'Role',
    key: 'Role',
    dataIndex: 'Role',
    render: (_, { Role }) => (
      <>
        {Role.map((tag) => {
          let color = tag.length > 5 ? 'geekblue' : 'green';
          if (tag === 'Admin') {
            color = '#173452';
          }
         else if (tag === 'HR') {
            color = '#173452';
          }
          else if (tag === 'Manager') {
            color= '#b5cce8';
          }
          return (
            <Tag color={color} key={tag}>
              {tag.toUpperCase()}
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: 'Date',
    dataIndex: 'Date',
    key: 'Date',
  },
  {
    title: 'Punch-In',
    dataIndex: 'PunchIn',
    key: 'PunchIn',
  },
  {
    title: 'Punch-Out',
    dataIndex: 'PunchOut',
    key: 'PunchOut',
  },
  
];

const dataa = users.length > 0 ? users.map((item, index) => ({
  key: index.toString(),
  Index: index + 1,
  Name: item.username || '',
  Role: [item.role || ''],
  Date:'20/02/2002',
  PunchIn:item.punch_in || '',
  PunchOut:item.punch_out || '',
  isActive: activeEmployees.some((activeUser) => activeUser.username === item.username),

})) : [];




  const [isIsFormOpenFor_TotalActiveEmployee, setIsFormOpenFor_TotalActiveEmployee] = useState(false);
  const [isIsFormOpenFor_OnTime, setIsFormOpenFor_OnTime] = useState(false);
  const [isIsFormOpenFor_Absent, setIsFormOpenFor_Absent] = useState(false);
  const [isIsFormOpenFor_LateArrival, setIsFormOpenFor_LateArrival] = useState(false);
  const [isIsFormOpenFor_HalfDayLeaves, setIsFormOpenFor_HalfDayLeaves] = useState(false);
  const [isIsFormOpenFor_DayOff, setIsFormOpenFor_DayOff] = useState(false);

  const openForm1 = () => {
    setIsFormOpenFor_TotalActiveEmployee(true);
  };

  const closeForm1 = () => {
    setIsFormOpenFor_TotalActiveEmployee(false);
  };

  const openForm2 = () => {
    setIsFormOpenFor_OnTime(true);
  };

  const closeForm2 = () => {
    setIsFormOpenFor_OnTime(false);
  };

  const openForm3 = () => {
    setIsFormOpenFor_Absent(true);
  };

  const closeForm3 = () => {
    setIsFormOpenFor_Absent(false);
  };

  const openForm4 = () => {
    setIsFormOpenFor_LateArrival(true);
  };

  const closeForm4 = () => {
    setIsFormOpenFor_LateArrival(false);
  };

  const openForm5 = () => {
    setIsFormOpenFor_HalfDayLeaves(true);
  };

  const closeForm5 = () => {
    setIsFormOpenFor_HalfDayLeaves(false);
  };

  const openForm6 = () => {
    setIsFormOpenFor_DayOff(true);
  };

  const closeForm6 = () => {
    setIsFormOpenFor_DayOff(false);
  };

  const ColumnsOf_TotalActiveEmployee = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno',
      key: 'Srno',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name2',
      key: 'Name2',
    },
  ];

  const dataOf_TotalActiveEmployee = activeEmployees.length > 0 ? activeEmployees.map((item, index) => ({
    key: index.toString(),
    Srno: index + 1,
    Name2: `${item.username} (${item.role}) ` || '',
  })) : [];


  const ColumnsOf_OnTime = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno2',
      key: 'Srno2',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name3',
      key: 'Name3',
    },
  ];
  const dataOf_OnTime = [
    {
      key: '1',
      Srno2: 1,
      Name3: '$OnTime',
    },
  ];


  const ColumnsOf_Absent = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno3',
      key: 'Srno3',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name4',
      key: 'Name4',
    },
  ];
  const dataOf_Absent = [
    {
      key: '1',
      Srno3: 1,
      Name4: '$Absent',
    },
  ];


  const ColumnsOf_LateArrival = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno4',
      key: 'Srno4',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name5',
      key: 'Name5',
    },
  ];
  const dataOf_LateArrival = [
    {
      key: '1',
      Srno4: 1,
      Name5: '$LateArrival',
    },
  ];


  const ColumnsOf_HalfDayLeaves = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno4',
      key: 'Srno4',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name5',
      key: 'Name5',
    },
  ];
  const dataOf_HalfDayLeaves = [
    {
      key: '1',
      Srno4: 1,
      Name5: '$HalfDayLeaves',
    },
  ];


  const ColumnsOf_DayOff = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno4',
      key: 'Srno4',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name5',
      key: 'Name5',
    },
  ];
  const dataOf_DayOff = [
    {
      key: '1',
      Srno4: 1,
      Name5: '$DayOff',
    },
  ];


return( 
<div>
    <SideMenuBar></SideMenuBar>
        
    <div class="content">
        <NewHeader></NewHeader>

        <main className="usercontrol_container">
        <div className='row2'>
            <h3 className='attendance_AttendancePage'>User Control</h3>   
        </div>
        
        <div className='row3_AttendancePage'>

            <DateRange
                className='dateRange_picker'
                editableDateInputs={true}
                onChange={item => setState([item.selection])}
                moveRangeOnFirstSelection={false}
                ranges={state}
            />    
        </div>

        <div class="row4_UserControl">
            <div class="column1_row4_UserControl">
                <div className='whiteBox_UserControl' onClick={openForm1}>
                    <p className='title_whiteBox_UserControl'>Total Active Employees</p>
                    <b><p className='data_whiteBox_UserControl'>{activeUserCount}</p></b>
                </div>
                {isIsFormOpenFor_TotalActiveEmployee && (
                <>
                <div className="overlay_UserControl" onClick={closeForm1}></div>
                    <div className="popup-form_UserControl">
                        <span className="close_UserControl" onClick={closeForm1}>&times;</span>
                            <p><b>Total Active Employees</b></p><br/>
                            {/* Your form content goes here */}
                            <form>
                            {/* Form fields go here */}
                                <div>
                                    <Table 
                                        columns={ColumnsOf_TotalActiveEmployee} 
                                        dataSource={dataOf_TotalActiveEmployee} 
                                        scroll={{ y: 400 }}
                                        pagination={false}
                                    />
                                </div>      
                            </form>
                    </div>
                </>
                )}


                <div className='whiteBox2_UserControl' onClick={openForm4}>
                    <p className='title_whiteBox_UserControl'>Late Arrival</p>
                    <b><p className='data_whiteBox_UserControl'>$123</p></b>
                </div>
                {isIsFormOpenFor_LateArrival && (
                <>
                <div className="overlay2_UserControl" onClick={closeForm4}></div>
                    <div className="popup-form2_UserControl">
                        <span className="close2_UserControl" onClick={closeForm4}>&times;</span>
                            <p><b>Late Arrival</b></p><br/>
                            {/* Your form content goes here */}
                            <form>
                            {/* Form fields go here */}
                                <div>
                                    <Table 
                                        columns={ColumnsOf_LateArrival} 
                                        dataSource={dataOf_LateArrival} 
                                        scroll={{ y: 400 }}
                                        pagination={false}
                                    />
                                </div>      
                            </form>
                    </div>
                </>
                )}
            </div>    
        
            <div class="column2_row4_UserControl">
                <div className='whiteBox_UserControl' onClick={openForm2}>
                    <p className='title_whiteBox_UserControl'>On Time</p>
                    <b><p className='data_whiteBox_UserControl'>$123</p></b>
                </div>
                {isIsFormOpenFor_OnTime && (
                <>
                <div className="overlay_UserControl" onClick={closeForm2}></div>
                    <div className="popup-form_UserControl">
                        <span className="close_UserControl" onClick={closeForm2}>&times;</span>
                            <p><b>On Time</b></p><br/>
                            {/* Your form content goes here */}
                            <form>
                            {/* Form fields go here */}
                                <div>
                                    <Table 
                                        columns={ColumnsOf_OnTime} 
                                        dataSource={dataOf_OnTime} 
                                        scroll={{ y: 400 }}
                                        pagination={false}
                                    />
                                </div>      
                            </form>
                    </div>
                </>
                )}

                <div className='whiteBox2_UserControl' onClick={openForm5}>
                    <p className='title_whiteBox_UserControl'>Half-day Leaves</p>
                    <b><p className='data_whiteBox_UserControl'>$123</p></b>
                </div>
                {isIsFormOpenFor_HalfDayLeaves && (
                <>
                <div className="overlay2_UserControl" onClick={closeForm5}></div>
                    <div className="popup-form2_UserControl">
                        <span className="close2_UserControl" onClick={closeForm5}>&times;</span>
                            <p><b>Half-day Leaves</b></p><br/>
                            {/* Your form content goes here */}
                            <form>
                            {/* Form fields go here */}
                                <div>
                                    <Table 
                                        columns={ColumnsOf_HalfDayLeaves} 
                                        dataSource={dataOf_HalfDayLeaves} 
                                        scroll={{ y: 400 }}
                                        pagination={false}
                                    />
                                </div>      
                            </form>
                    </div>
                </>
                )}
            </div>
  
            <div class="column3_row4_UserControl">
                <div className='whiteBox_UserControl' onClick={openForm3}>
                    <p className='title_whiteBox_UserControl'>Absent</p>
                    <b><p className='data_whiteBox_UserControl'>$123</p></b>
                </div>
                {isIsFormOpenFor_Absent && (
                <>
                <div className="overlay_UserControl" onClick={closeForm3}></div>
                    <div className="popup-form_UserControl">
                        <span className="close_UserControl" onClick={closeForm3}>&times;</span>
                            <p><b>Absent</b></p><br/>
                            {/* Your form content goes here */}
                            <form>
                            {/* Form fields go here */}
                                <div>
                                    <Table 
                                        columns={ColumnsOf_Absent} 
                                        dataSource={dataOf_Absent} 
                                        scroll={{ y: 400 }}
                                        pagination={false}
                                    />
                                </div>      
                            </form>
                    </div>
                </>
                )}

                <div className='whiteBox2_UserControl' onClick={openForm6}>
                    <p className='title_whiteBox_UserControl'>Day-off</p>
                    <b><p className='data_whiteBox_UserControl'>$123</p></b>
                </div>
                {isIsFormOpenFor_DayOff && (
                <>
                <div className="overlay2_UserControl" onClick={closeForm6}></div>
                    <div className="popup-form2_UserControl">
                        <span className="close2_UserControl" onClick={closeForm6}>&times;</span>
                            <p><b>Day-Off</b></p><br/>
                            {/* Your form content goes here */}
                            <form>
                            {/* Form fields go here */}
                                <div>
                                    <Table 
                                        columns={ColumnsOf_DayOff} 
                                        dataSource={dataOf_DayOff} 
                                        scroll={{ y: 400 }}
                                        pagination={false}
                                    />
                                </div>      
                            </form>
                    </div>
                </>
                )}
            </div>
        </div>

        <div className='table_UserControl'>
            <Table 
              columns={columns} 
              dataSource={dataa} 
              scroll={{ y: 240 }}
              pagination={false}
            />
          </div>   

    <br/>
        </main>
    </div>
</div>
 )
}

export default UserControl;